import React, { useContext } from 'react'
import { Box, Message, Text } from '@postenbring/hedwig-react'
import { InternationalCalculatorContext } from '../InternationalCalculatorContext'

export const ResultDisplay = ({ labels }) => {
    const {
        error,
        priceValue,
        priceValueAdditional,
        subDisplayCategory,
        zoneCount,
        shippingWeightValue,
        submittedDimensions,
        descriptionText,
        workingDays,
        maxWeight
    } = useContext(InternationalCalculatorContext)


  const formatNumber = (value) =>
    new Intl.NumberFormat('nb-NO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)

  return (
    <Box style={{ backgroundColor: 'white' }}>
        {error && (
            <Message variant="attention" lang="no">
            <Message.Description>
                <Text>{error}</Text>
            </Message.Description>
            </Message>
        )}

        {priceValue && subDisplayCategory && (
            <Text variant="h3">{subDisplayCategory}</Text>
        )}

        {priceValue && zoneCount && (
            <Text className="hds-mt-16-20">
            {zoneCount} {labels.zoneCountText}, {formatNumber(shippingWeightValue)} kg, 
            {` ${submittedDimensions.length} x ${submittedDimensions.width} x ${submittedDimensions.height} cm`}
            </Text>
        )}

        {priceValue && (
            <>
            <div className="hds-mt-16-20" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Text> 
                    {labels.priceText} 
                </Text>
                <Text>
                    {formatNumber(priceValue)} Kr
                </Text>
            </div>
            <Text>
                ({labels.shippingWeightText} {formatNumber(shippingWeightValue)} kg {labels.priceExMvaText})
            </Text>
            </>
        )}

        {priceValue && priceValueAdditional && (
            <>
            <div className="hds-mt-16-20" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text>{labels.priceTextAdditional}</Text>
            <Text>{formatNumber(priceValueAdditional)} Kr</Text>
            </div>
            <Text>({labels.priceTextAdditionalDetails})</Text>
            </>
        )}

        {priceValue && descriptionText && (
            <Text className="hds-mt-16-20">{descriptionText}</Text>
        )}
        {priceValue && workingDays && (
            <Text className="hds-mt-16-20">
            {labels.workingDaysText} {workingDays}
            </Text>
        )}

        {priceValue && maxWeight && (
            <Text className="hds-mt-16-20">
            {labels.maxWeightText} {formatNumber(maxWeight)} kg
            </Text>
        )}
    </Box>
  )
}